import { ANALYSIS_CARD_IDS, type AnalysisCardId } from "src-next/modules/clinical-insights/types/analysisTypes";

export const ANALYSIS_QUERY_PARAM = "analise";
export const DEFAULT_ANALYSIS_ID = "condutas" as const;

export function isAnalysisCardId(value: string | null): value is AnalysisCardId {
  return (
    value !== null &&
    (ANALYSIS_CARD_IDS as readonly string[]).includes(value)
  );
}
